/* eslint-disable */
import React from "react";
import styles from "./TitleWithDetailedClick.module.css";

const TitleWithDetailedClick = ({
    title = "Title",
    showBackButton = false,
    showDetailedButton = true,
    handleBackClick,
    handleDetailClick
}) => {
    return (
        <div className={styles.domain_tile}>
            <div className={styles.domain_tile_header}>
                <span>{title}</span>
            </div>
            {showDetailedButton && (
                <button
                    className={styles.back_button}
                    onClick={handleDetailClick}
                >
                    Detailed View <span className={styles.arrow}>→</span>
                </button>
            )}
            {showBackButton && (
                <button
                    className={styles.back_button}
                    onClick={handleBackClick}
                >
                    <span className={styles.arrow}>←</span> Back
                </button>
            )}
        </div>
    );
};

export default TitleWithDetailedClick;
